module.exports = "<div class=\"ubg-left-column ubg-layout-column\">\n  <ng-content></ng-content>\n</div>"